import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import AuthContext from "context/AuthContext";
import { useContext } from "react";
import { useTranslation } from "react-i18next";
import BottomSheet from "./reusable/BottomSheet";

export default function LanguageSelect({ onClose }) {
  const { t, i18n } = useTranslation();
  const { language, setLanguage } = useContext(AuthContext);

  return (
    <BottomSheet title={t("O_LANGUAGE")} open={true} onClose={onClose}>
      <div
        className="px-4 flex justify-start items-center gap-3 mb-3 cursor-pointer"
        onClick={() => {
          setLanguage(2);
          i18n.changeLanguage("al");
          localStorage.setItem("language", "al");
          onClose();
        }}
      >
        <FontAwesomeIcon icon={faCheck} className={`${language === 2 ? "block" : "invisible"}`} size="xl" />
        <span className="font-medium text-lg">Shqip</span>
      </div>

      <div
        className="px-4 flex justify-start items-center gap-3 mb-3 cursor-pointer"
        onClick={() => {
          setLanguage(1);
          i18n.changeLanguage("en");
          localStorage.setItem("language", "en");
          onClose();
        }}
      >
        <FontAwesomeIcon icon={faCheck} className={`${language === 1 ? "block" : "invisible"}`} size="xl" />
        <span className="font-medium text-lg">English</span>
      </div>
    </BottomSheet>
  );
}
